/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */
export var MetricEventEventName;
(function (MetricEventEventName) {
    MetricEventEventName["compile_completed"] = "compile.completed";
    MetricEventEventName["compile_started"] = "compile.started";
    MetricEventEventName["did_action"] = "did.action";
    MetricEventEventName["gem_changed"] = "gem.changed";
    MetricEventEventName["ide_canvas_event_counts"] = "ide.canvas.event_counts";
    MetricEventEventName["ide_canvas_operation"] = "ide.canvas.operation";
    MetricEventEventName["ide_code_regen"] = "ide.code_regen";
    MetricEventEventName["ide_compilation"] = "ide.compilation";
    MetricEventEventName["ide_copilot_request"] = "ide.copilot.request";
    MetricEventEventName["ide_data_loaded"] = "ide.data.loaded";
    MetricEventEventName["ide_fabric_connection_connected"] = "ide.fabric.connection.connected";
    MetricEventEventName["ide_fabric_connection_disconnected"] = "ide.fabric.connection.disconnected";
    MetricEventEventName["ide_fabric_connection_started"] = "ide.fabric.connection.started";
    MetricEventEventName["ide_gem_code_generation"] = "ide.gem.code_generation";
    MetricEventEventName["ide_gem_compilation"] = "ide.gem.compilation";
    MetricEventEventName["ide_job_opened"] = "ide.job.opened";
    MetricEventEventName["ide_job_save"] = "ide.job.save";
    MetricEventEventName["ide_knowledge_graph_lineage_query"] = "ide.knowledge_graph.lineage_query";
    MetricEventEventName["ide_pipeline_code_generation"] = "ide.pipeline.code_generation";
    MetricEventEventName["ide_pipeline_opened"] = "ide.pipeline.opened";
    MetricEventEventName["ide_pipeline_run_snapshot_saved"] = "ide.pipeline.run_snapshot_saved";
    MetricEventEventName["ide_pipeline_schedule_changed"] = "ide.pipeline.schedule.changed";
    MetricEventEventName["ide_project_opened"] = "ide.project.opened";
    MetricEventEventName["ide_project_save"] = "ide.project.save";
    MetricEventEventName["ide_run"] = "ide.run";
    MetricEventEventName["ide_sandbox_acquisition"] = "ide.sandbox.acquisition";
    MetricEventEventName["ide_sandbox_usage"] = "ide.sandbox.usage";
    MetricEventEventName["ide_server_connected"] = "ide.server.connected";
    MetricEventEventName["ide_session_codegen_completed"] = "ide.session.codegen_completed";
    MetricEventEventName["ide_session_compilation_done"] = "ide.session.compilation_done";
    MetricEventEventName["ide_session_initialize_received"] = "ide.session.initialize_received";
    MetricEventEventName["ide_session_initialize_sent"] = "ide.session.initialize_sent";
    MetricEventEventName["ide_session_project_usable"] = "ide.session.project_usable";
    MetricEventEventName["ide_upload_rejected"] = "ide.upload.rejected";
    MetricEventEventName["metadata_entity_mutation"] = "metadata.entity.mutation";
    MetricEventEventName["metadata_git_pull_request"] = "metadata.git.pull_request";
    MetricEventEventName["metadata_graphql_operation"] = "metadata.graphql.operation";
    MetricEventEventName["metadata_release_created"] = "metadata.release.created";
    MetricEventEventName["metadata_release_deployment"] = "metadata.release.deployment";
    MetricEventEventName["metadata_search_query"] = "metadata.search.query";
    MetricEventEventName["metagraph_api_call"] = "metagraph.api.call";
    MetricEventEventName["metagraph_git_operation"] = "metagraph.git.operation";
    MetricEventEventName["metagraph_git_pr_merge_completed"] = "metagraph.git.pr_merge_completed";
    MetricEventEventName["orchestrator_interims_completed"] = "orchestrator.interims.completed";
    MetricEventEventName["orchestrator_pipeline_run"] = "orchestrator.pipeline.run";
    MetricEventEventName["pipeline_created"] = "pipeline.created";
    MetricEventEventName["pipeline_scheduled"] = "pipeline.scheduled";
    MetricEventEventName["project_created"] = "project.created";
    MetricEventEventName["run_cleanup"] = "run.cleanup";
    MetricEventEventName["run_execute"] = "run.execute";
    MetricEventEventName["run_file_handoff"] = "run.file_handoff";
    MetricEventEventName["run_file_sync"] = "run.file_sync";
    MetricEventEventName["run_oauth_sync"] = "run.oauth_sync";
    MetricEventEventName["run_plan"] = "run.plan";
    MetricEventEventName["run_query_firstResponse"] = "run.query.firstResponse";
    MetricEventEventName["run_sandbox_acquire"] = "run.sandbox_acquire";
    MetricEventEventName["run_sandbox_initialize"] = "run.sandbox_initialize";
    MetricEventEventName["run_started"] = "run.started";
    MetricEventEventName["runtime_error"] = "runtime.error";
    MetricEventEventName["sandbox_activeCount"] = "sandbox.activeCount";
    MetricEventEventName["sandbox_allocated"] = "sandbox.allocated";
    MetricEventEventName["sandbox_created"] = "sandbox.created";
    MetricEventEventName["sandbox_ready"] = "sandbox.ready";
    MetricEventEventName["ui_add_new_node"] = "ui.add.new.node";
    MetricEventEventName["ui_ai_suggestion_shown"] = "ui.ai.suggestion_shown";
    MetricEventEventName["ui_analysis_entity_creation_successful"] = "ui.analysis.entity.creation.successful";
    MetricEventEventName["ui_analysis_modified"] = "ui.analysis.modified";
    MetricEventEventName["ui_analysis_opened"] = "ui.analysis.opened";
    MetricEventEventName["ui_analysis_run_completed"] = "ui.analysis.run.completed";
    MetricEventEventName["ui_analysis_run_started"] = "ui.analysis.run.started";
    MetricEventEventName["ui_billing_plan_changed"] = "ui.billing.plan_changed";
    MetricEventEventName["ui_billing_upgradeToEnterprise"] = "ui.billing.upgradeToEnterprise";
    MetricEventEventName["ui_billing_upgradeToPro"] = "ui.billing.upgradeToPro";
    MetricEventEventName["ui_blocking_spinner"] = "ui.blocking.spinner";
    MetricEventEventName["ui_copilot_agent_autoRun_start"] = "ui.copilot.agent.autoRun.start";
    MetricEventEventName["ui_copilot_agent_autoRun_success"] = "ui.copilot.agent.autoRun.success";
    MetricEventEventName["ui_copilot_agent_inspectData_start"] = "ui.copilot.agent.inspectData.start";
    MetricEventEventName["ui_copilot_agent_messageFeedback_submit"] = "ui.copilot.agent.messageFeedback.submit";
    MetricEventEventName["ui_copilot_agent_v4_feedback_downvote"] = "ui.copilot.agent.v4.feedback.downvote";
    MetricEventEventName["ui_copilot_agent_v4_feedback_upvote"] = "ui.copilot.agent.v4.feedback.upvote";
    MetricEventEventName["ui_copilot_agent_v4_response"] = "ui.copilot.agent.v4.response";
    MetricEventEventName["ui_copilot_agent_v4_user_prompt_send"] = "ui.copilot.agent.v4.user.prompt.send";
    MetricEventEventName["ui_copilot_ask_ai"] = "ui.copilot.ask.ai";
    MetricEventEventName["ui_copilot_code_applied"] = "ui.copilot.code_applied";
    MetricEventEventName["ui_copilot_fix"] = "ui.copilot.fix";
    MetricEventEventName["ui_copilot_suggesstion_accept"] = "ui.copilot.suggesstion.accept";
    MetricEventEventName["ui_create_dataset"] = "ui.create.dataset";
    MetricEventEventName["ui_data_loaded"] = "ui.data.loaded";
    MetricEventEventName["ui_data_mapping_end"] = "ui.data_mapping.end";
    MetricEventEventName["ui_data_mapping_start"] = "ui.data_mapping.start";
    MetricEventEventName["ui_expression_view_toggle"] = "ui.expression.view.toggle";
    MetricEventEventName["ui_fabric_connection_attempt_failed"] = "ui.fabric.connection.attempt_failed";
    MetricEventEventName["ui_fabric_connection_auto_attach_skipped"] = "ui.fabric.connection.auto_attach_skipped";
    MetricEventEventName["ui_fabric_connection_connected"] = "ui.fabric.connection.connected";
    MetricEventEventName["ui_fabric_connection_disconnected"] = "ui.fabric.connection.disconnected";
    MetricEventEventName["ui_fabric_connection_retries_exhausted"] = "ui.fabric.connection.retries_exhausted";
    MetricEventEventName["ui_fabric_connection_started"] = "ui.fabric.connection.started";
    MetricEventEventName["ui_fabric_connection_tested"] = "ui.fabric.connection_tested";
    MetricEventEventName["ui_fabric_entity_creation_successful"] = "ui.fabric.entity.creation.successful";
    MetricEventEventName["ui_gem_action"] = "ui.gem.action";
    MetricEventEventName["ui_gem_close_dialog"] = "ui.gem.close.dialog";
    MetricEventEventName["ui_gem_mode_toggle"] = "ui.gem.mode.toggle";
    MetricEventEventName["ui_gem_open_dialog"] = "ui.gem.open.dialog";
    MetricEventEventName["ui_gem_save_dialog"] = "ui.gem.save.dialog";
    MetricEventEventName["ui_gem_too_complex"] = "ui.gem.too.complex";
    MetricEventEventName["ui_ide_pipeline_add_new_node"] = "ui.ide.pipeline.add.new.node";
    MetricEventEventName["ui_ide_pipeline_replay_end"] = "ui.ide.pipeline.replay.end";
    MetricEventEventName["ui_ide_pipeline_replay_item_new"] = "ui.ide.pipeline.replay.item.new";
    MetricEventEventName["ui_ide_pipeline_replay_start"] = "ui.ide.pipeline.replay.start";
    MetricEventEventName["ui_interactive_componentLevel_run"] = "ui.interactive.componentLevel.run";
    MetricEventEventName["ui_interactive_full_run"] = "ui.interactive.full.run";
    MetricEventEventName["ui_interactive_run_cancelRequested"] = "ui.interactive.run.cancelRequested";
    MetricEventEventName["ui_interactive_run_codegen_completed"] = "ui.interactive.run.codegen.completed";
    MetricEventEventName["ui_interactive_run_compile_completed"] = "ui.interactive.run.compile.completed";
    MetricEventEventName["ui_interactive_run_completed"] = "ui.interactive.run.completed";
    MetricEventEventName["ui_interactive_run_compute_ready"] = "ui.interactive.run.compute.ready";
    MetricEventEventName["ui_interactive_run_firstResult"] = "ui.interactive.run.firstResult";
    MetricEventEventName["ui_interactive_run_submission_completed"] = "ui.interactive.run.submission.completed";
    MetricEventEventName["ui_interactive_run_submission_started"] = "ui.interactive.run.submission.started";
    MetricEventEventName["ui_interim_received"] = "ui.interim.received";
    MetricEventEventName["ui_job_entity_creation_successful"] = "ui.job.entity.creation.successful";
    MetricEventEventName["ui_job_opened"] = "ui.job.opened";
    MetricEventEventName["ui_metadata_create_fabric"] = "ui.metadata.create.fabric";
    MetricEventEventName["ui_metadata_ui_page_load"] = "ui.metadata.ui.page.load";
    MetricEventEventName["ui_modified_component"] = "ui.modified.component";
    MetricEventEventName["ui_onboarding_ds_create"] = "ui.onboarding.ds.create";
    MetricEventEventName["ui_onboarding_end"] = "ui.onboarding.end";
    MetricEventEventName["ui_onboarding_fabric_create"] = "ui.onboarding.fabric.create";
    MetricEventEventName["ui_onboarding_fabric_update"] = "ui.onboarding.fabric.update";
    MetricEventEventName["ui_onboarding_home_flowType"] = "ui.onboarding.home.flowType";
    MetricEventEventName["ui_onboarding_pipeline_envInfo"] = "ui.onboarding.pipeline.envInfo";
    MetricEventEventName["ui_onboarding_pipeline_run"] = "ui.onboarding.pipeline.run";
    MetricEventEventName["ui_onboarding_project_create"] = "ui.onboarding.project.create";
    MetricEventEventName["ui_onboarding_questionnaire_end"] = "ui.onboarding.questionnaire.end";
    MetricEventEventName["ui_page_callSummary"] = "ui.page.callSummary";
    MetricEventEventName["ui_page_dbsignup_createPasswordSuccess"] = "ui.page.dbsignup.createPasswordSuccess";
    MetricEventEventName["ui_page_load"] = "ui.page.load";
    MetricEventEventName["ui_page_resetPassword_ResetPasswordButtonClicked"] = "ui.page.resetPassword.ResetPasswordButtonClicked";
    MetricEventEventName["ui_page_signin_login_attempt"] = "ui.page.signin.login_attempt";
    MetricEventEventName["ui_page_signin_passwordLanding"] = "ui.page.signin.passwordLanding";
    MetricEventEventName["ui_page_signin_signinLandingPage"] = "ui.page.signin.signinLandingPage";
    MetricEventEventName["ui_page_signup_CreatePasswordButtonClicked"] = "ui.page.signup.CreatePasswordButtonClicked";
    MetricEventEventName["ui_page_signup_CreateTeamButtonClicked"] = "ui.page.signup.CreateTeamButtonClicked";
    MetricEventEventName["ui_page_signup_OtpLandingPage"] = "ui.page.signup.OtpLandingPage";
    MetricEventEventName["ui_page_signup_UserProfileSubmitButtonClicked"] = "ui.page.signup.UserProfileSubmitButtonClicked";
    MetricEventEventName["ui_page_signup_VerifyOTPButtonClicked"] = "ui.page.signup.VerifyOTPButtonClicked";
    MetricEventEventName["ui_page_signup_databricksLandingPage"] = "ui.page.signup.databricksLandingPage";
    MetricEventEventName["ui_page_signup_step_completed"] = "ui.page.signup.step.completed";
    MetricEventEventName["ui_page_signup_step_otp"] = "ui.page.signup.step.otp";
    MetricEventEventName["ui_page_signup_step_password"] = "ui.page.signup.step.password";
    MetricEventEventName["ui_page_signup_step_signup"] = "ui.page.signup.step.signup";
    MetricEventEventName["ui_page_signup_step_userProfile"] = "ui.page.signup.step.userProfile";
    MetricEventEventName["ui_pipeline_code_generation"] = "ui.pipeline.code_generation";
    MetricEventEventName["ui_pipeline_entity_creation_successful"] = "ui.pipeline.entity.creation.successful";
    MetricEventEventName["ui_pipeline_opened"] = "ui.pipeline.opened";
    MetricEventEventName["ui_pipeline_schedule_changed"] = "ui.pipeline.schedule.changed";
    MetricEventEventName["ui_pipeline_view_toggle"] = "ui.pipeline.view.toggle";
    MetricEventEventName["ui_project_entity_creation_successful"] = "ui.project.entity.creation.successful";
    MetricEventEventName["ui_project_opened"] = "ui.project.opened";
    MetricEventEventName["ui_run_job"] = "ui.run.job";
    MetricEventEventName["ui_runtime_error"] = "ui.runtime.error";
    MetricEventEventName["ui_session_compile_failed"] = "ui.session.compile_failed";
    MetricEventEventName["ui_session_compile_finish"] = "ui.session.compile_finish";
    MetricEventEventName["ui_session_connect"] = "ui.session.connect";
    MetricEventEventName["ui_session_data_load"] = "ui.session.data_load";
    MetricEventEventName["ui_session_did_open"] = "ui.session.did_open";
    MetricEventEventName["ui_session_editable"] = "ui.session.editable";
    MetricEventEventName["ui_session_metadata_loaded"] = "ui.session.metadata_loaded";
    MetricEventEventName["ui_session_open_click"] = "ui.session.open_click";
    MetricEventEventName["ui_session_pipeline_show"] = "ui.session.pipeline_show";
    MetricEventEventName["ui_session_project_usable"] = "ui.session.project_usable";
    MetricEventEventName["ui_session_sandbox_ready"] = "ui.session.sandbox_ready";
    MetricEventEventName["ui_show_the_preview"] = "ui.show.the.preview";
    MetricEventEventName["ui_sql_ide_component_add"] = "ui.sql.ide.component.add";
    MetricEventEventName["ui_sql_ide_model_add"] = "ui.sql.ide.model.add";
    MetricEventEventName["ui_sql_ide_source_add"] = "ui.sql.ide.source.add";
    MetricEventEventName["ui_sql_ide_source_connection_add"] = "ui.sql.ide.source.connection.add";
    MetricEventEventName["ui_template_gallery_viewed"] = "ui.template.gallery_viewed";
    MetricEventEventName["ui_template_industry_selected"] = "ui.template.industry_selected";
    MetricEventEventName["ui_template_previewed"] = "ui.template.previewed";
    MetricEventEventName["ui_template_used"] = "ui.template.used";
    MetricEventEventName["ui_transpiler_import_transpilation_failed"] = "ui.transpiler.import.transpilation.failed";
    MetricEventEventName["ui_transpiler_import_transpilation_start"] = "ui.transpiler.import.transpilation.start";
    MetricEventEventName["ui_transpiler_import_transpilation_success"] = "ui.transpiler.import.transpilation.success";
    MetricEventEventName["ui_upgrade_plan_user_start"] = "ui.upgrade.plan.user.start";
})(MetricEventEventName || (MetricEventEventName = {}));
export var BaseEventEventType;
(function (BaseEventEventType) {
    BaseEventEventType["lifecycle"] = "lifecycle";
    BaseEventEventType["userAction"] = "userAction";
    BaseEventEventType["system"] = "system";
    BaseEventEventType["audit"] = "audit";
})(BaseEventEventType || (BaseEventEventType = {}));
export var MetadataGraphqlOperationPayloadOperation;
(function (MetadataGraphqlOperationPayloadOperation) {
    MetadataGraphqlOperationPayloadOperation["query"] = "query";
    MetadataGraphqlOperationPayloadOperation["mutation"] = "mutation";
    MetadataGraphqlOperationPayloadOperation["subscription"] = "subscription";
})(MetadataGraphqlOperationPayloadOperation || (MetadataGraphqlOperationPayloadOperation = {}));
export var RunFileSyncPayloadSyncType;
(function (RunFileSyncPayloadSyncType) {
    RunFileSyncPayloadSyncType["full"] = "full";
    RunFileSyncPayloadSyncType["partial"] = "partial";
    RunFileSyncPayloadSyncType["temporary"] = "temporary";
})(RunFileSyncPayloadSyncType || (RunFileSyncPayloadSyncType = {}));
export var UiAddNewNodePayloadNodeType;
(function (UiAddNewNodePayloadNodeType) {
    UiAddNewNodePayloadNodeType["pipeline"] = "pipeline";
    UiAddNewNodePayloadNodeType["dataset"] = "dataset";
    UiAddNewNodePayloadNodeType["condition"] = "condition";
})(UiAddNewNodePayloadNodeType || (UiAddNewNodePayloadNodeType = {}));
export var UiAiSuggestionShownPayloadTool;
(function (UiAiSuggestionShownPayloadTool) {
    UiAiSuggestionShownPayloadTool["DataExplorer"] = "DataExplorer";
    UiAiSuggestionShownPayloadTool["PipelineBuilder"] = "PipelineBuilder";
    UiAiSuggestionShownPayloadTool["CodeEditor"] = "CodeEditor";
    UiAiSuggestionShownPayloadTool["Copilot"] = "Copilot";
})(UiAiSuggestionShownPayloadTool || (UiAiSuggestionShownPayloadTool = {}));
export var UiAiSuggestionShownPayloadSuggestionType;
(function (UiAiSuggestionShownPayloadSuggestionType) {
    UiAiSuggestionShownPayloadSuggestionType["generation"] = "generation";
    UiAiSuggestionShownPayloadSuggestionType["suggestion"] = "suggestion";
    UiAiSuggestionShownPayloadSuggestionType["errorFix"] = "errorFix";
    UiAiSuggestionShownPayloadSuggestionType["refactor"] = "refactor";
})(UiAiSuggestionShownPayloadSuggestionType || (UiAiSuggestionShownPayloadSuggestionType = {}));
export var UiAnalysisEntityCreationSuccessfulPayloadSource;
(function (UiAnalysisEntityCreationSuccessfulPayloadSource) {
    UiAnalysisEntityCreationSuccessfulPayloadSource["blank"] = "blank";
    UiAnalysisEntityCreationSuccessfulPayloadSource["template"] = "template";
    UiAnalysisEntityCreationSuccessfulPayloadSource["ai"] = "ai";
})(UiAnalysisEntityCreationSuccessfulPayloadSource || (UiAnalysisEntityCreationSuccessfulPayloadSource = {}));
export var UiBillingPlanChangedPayloadFromPlan;
(function (UiBillingPlanChangedPayloadFromPlan) {
    UiBillingPlanChangedPayloadFromPlan["Starter"] = "Starter";
    UiBillingPlanChangedPayloadFromPlan["Pro"] = "Pro";
    UiBillingPlanChangedPayloadFromPlan["Enterprise"] = "Enterprise";
})(UiBillingPlanChangedPayloadFromPlan || (UiBillingPlanChangedPayloadFromPlan = {}));
export var UiBillingPlanChangedPayloadToPlan;
(function (UiBillingPlanChangedPayloadToPlan) {
    UiBillingPlanChangedPayloadToPlan["Starter"] = "Starter";
    UiBillingPlanChangedPayloadToPlan["Pro"] = "Pro";
    UiBillingPlanChangedPayloadToPlan["Enterprise"] = "Enterprise";
})(UiBillingPlanChangedPayloadToPlan || (UiBillingPlanChangedPayloadToPlan = {}));
export var UiBillingPlanChangedPayloadDirection;
(function (UiBillingPlanChangedPayloadDirection) {
    UiBillingPlanChangedPayloadDirection["upgrade"] = "upgrade";
    UiBillingPlanChangedPayloadDirection["downgrade"] = "downgrade";
})(UiBillingPlanChangedPayloadDirection || (UiBillingPlanChangedPayloadDirection = {}));
export var UiBillingUpgradeToEnterprisePayloadFromPlan;
(function (UiBillingUpgradeToEnterprisePayloadFromPlan) {
    UiBillingUpgradeToEnterprisePayloadFromPlan["Starter"] = "Starter";
    UiBillingUpgradeToEnterprisePayloadFromPlan["Pro"] = "Pro";
    UiBillingUpgradeToEnterprisePayloadFromPlan["Enterprise"] = "Enterprise";
})(UiBillingUpgradeToEnterprisePayloadFromPlan || (UiBillingUpgradeToEnterprisePayloadFromPlan = {}));
export var UiBillingUpgradeToEnterprisePayloadToPlan;
(function (UiBillingUpgradeToEnterprisePayloadToPlan) {
    UiBillingUpgradeToEnterprisePayloadToPlan["Starter"] = "Starter";
    UiBillingUpgradeToEnterprisePayloadToPlan["Pro"] = "Pro";
    UiBillingUpgradeToEnterprisePayloadToPlan["Enterprise"] = "Enterprise";
})(UiBillingUpgradeToEnterprisePayloadToPlan || (UiBillingUpgradeToEnterprisePayloadToPlan = {}));
export var UiBillingUpgradeToEnterprisePayloadDirection;
(function (UiBillingUpgradeToEnterprisePayloadDirection) {
    UiBillingUpgradeToEnterprisePayloadDirection["upgrade"] = "upgrade";
    UiBillingUpgradeToEnterprisePayloadDirection["downgrade"] = "downgrade";
})(UiBillingUpgradeToEnterprisePayloadDirection || (UiBillingUpgradeToEnterprisePayloadDirection = {}));
export var UiBillingUpgradeToProPayloadFromPlan;
(function (UiBillingUpgradeToProPayloadFromPlan) {
    UiBillingUpgradeToProPayloadFromPlan["Starter"] = "Starter";
    UiBillingUpgradeToProPayloadFromPlan["Pro"] = "Pro";
    UiBillingUpgradeToProPayloadFromPlan["Enterprise"] = "Enterprise";
})(UiBillingUpgradeToProPayloadFromPlan || (UiBillingUpgradeToProPayloadFromPlan = {}));
export var UiBillingUpgradeToProPayloadToPlan;
(function (UiBillingUpgradeToProPayloadToPlan) {
    UiBillingUpgradeToProPayloadToPlan["Starter"] = "Starter";
    UiBillingUpgradeToProPayloadToPlan["Pro"] = "Pro";
    UiBillingUpgradeToProPayloadToPlan["Enterprise"] = "Enterprise";
})(UiBillingUpgradeToProPayloadToPlan || (UiBillingUpgradeToProPayloadToPlan = {}));
export var UiBillingUpgradeToProPayloadDirection;
(function (UiBillingUpgradeToProPayloadDirection) {
    UiBillingUpgradeToProPayloadDirection["upgrade"] = "upgrade";
    UiBillingUpgradeToProPayloadDirection["downgrade"] = "downgrade";
})(UiBillingUpgradeToProPayloadDirection || (UiBillingUpgradeToProPayloadDirection = {}));
export var UiCopilotAgentMessageFeedbackSubmitPayloadFeedbackType;
(function (UiCopilotAgentMessageFeedbackSubmitPayloadFeedbackType) {
    UiCopilotAgentMessageFeedbackSubmitPayloadFeedbackType["upvote"] = "upvote";
    UiCopilotAgentMessageFeedbackSubmitPayloadFeedbackType["downvote"] = "downvote";
})(UiCopilotAgentMessageFeedbackSubmitPayloadFeedbackType || (UiCopilotAgentMessageFeedbackSubmitPayloadFeedbackType = {}));
export var UiCopilotAskAiPayloadAction;
(function (UiCopilotAskAiPayloadAction) {
    UiCopilotAskAiPayloadAction["triggered"] = "triggered";
    UiCopilotAskAiPayloadAction["shown"] = "shown";
    UiCopilotAskAiPayloadAction["accepted"] = "accepted";
    UiCopilotAskAiPayloadAction["typing"] = "typing";
})(UiCopilotAskAiPayloadAction || (UiCopilotAskAiPayloadAction = {}));
export var UiCopilotAskAiPayloadTriggerType;
(function (UiCopilotAskAiPayloadTriggerType) {
    UiCopilotAskAiPayloadTriggerType["user"] = "user";
    UiCopilotAskAiPayloadTriggerType["auto"] = "auto";
})(UiCopilotAskAiPayloadTriggerType || (UiCopilotAskAiPayloadTriggerType = {}));
export var UiCopilotFixPayloadCopilotFixType;
(function (UiCopilotFixPayloadCopilotFixType) {
    UiCopilotFixPayloadCopilotFixType["expression"] = "expression";
    UiCopilotFixPayloadCopilotFixType["gem"] = "gem";
})(UiCopilotFixPayloadCopilotFixType || (UiCopilotFixPayloadCopilotFixType = {}));
export var UiCopilotFixPayloadTriggerPoint;
(function (UiCopilotFixPayloadTriggerPoint) {
    UiCopilotFixPayloadTriggerPoint["expressionBox"] = "expressionBox";
    UiCopilotFixPayloadTriggerPoint["gemDiagnosticDrawer"] = "gemDiagnosticDrawer";
    UiCopilotFixPayloadTriggerPoint["footerDiagnosticDrawer"] = "footerDiagnosticDrawer";
    UiCopilotFixPayloadTriggerPoint["gemMenu"] = "gemMenu";
    UiCopilotFixPayloadTriggerPoint["gemSavePopup"] = "gemSavePopup";
})(UiCopilotFixPayloadTriggerPoint || (UiCopilotFixPayloadTriggerPoint = {}));
export var UiCopilotFixPayloadStatus;
(function (UiCopilotFixPayloadStatus) {
    UiCopilotFixPayloadStatus["success"] = "success";
    UiCopilotFixPayloadStatus["error"] = "error";
})(UiCopilotFixPayloadStatus || (UiCopilotFixPayloadStatus = {}));
export var UiCopilotSuggesstionAcceptPayloadTool;
(function (UiCopilotSuggesstionAcceptPayloadTool) {
    UiCopilotSuggesstionAcceptPayloadTool["DataExplorer"] = "DataExplorer";
    UiCopilotSuggesstionAcceptPayloadTool["PipelineBuilder"] = "PipelineBuilder";
    UiCopilotSuggesstionAcceptPayloadTool["CodeEditor"] = "CodeEditor";
    UiCopilotSuggesstionAcceptPayloadTool["Copilot"] = "Copilot";
})(UiCopilotSuggesstionAcceptPayloadTool || (UiCopilotSuggesstionAcceptPayloadTool = {}));
export var UiCopilotSuggesstionAcceptPayloadSuggestionType;
(function (UiCopilotSuggesstionAcceptPayloadSuggestionType) {
    UiCopilotSuggesstionAcceptPayloadSuggestionType["generation"] = "generation";
    UiCopilotSuggesstionAcceptPayloadSuggestionType["suggestion"] = "suggestion";
    UiCopilotSuggesstionAcceptPayloadSuggestionType["errorFix"] = "errorFix";
    UiCopilotSuggesstionAcceptPayloadSuggestionType["refactor"] = "refactor";
})(UiCopilotSuggesstionAcceptPayloadSuggestionType || (UiCopilotSuggesstionAcceptPayloadSuggestionType = {}));
export var UiCreateDatasetPayloadDatasetType;
(function (UiCreateDatasetPayloadDatasetType) {
    UiCreateDatasetPayloadDatasetType["source"] = "source";
    UiCreateDatasetPayloadDatasetType["target"] = "target";
})(UiCreateDatasetPayloadDatasetType || (UiCreateDatasetPayloadDatasetType = {}));
export var UiDataMappingEndPayloadMappingType;
(function (UiDataMappingEndPayloadMappingType) {
    UiDataMappingEndPayloadMappingType["schema"] = "schema";
    UiDataMappingEndPayloadMappingType["expression"] = "expression";
    UiDataMappingEndPayloadMappingType["join"] = "join";
    UiDataMappingEndPayloadMappingType["aggregate"] = "aggregate";
})(UiDataMappingEndPayloadMappingType || (UiDataMappingEndPayloadMappingType = {}));
export var UiDataMappingStartPayloadMappingType;
(function (UiDataMappingStartPayloadMappingType) {
    UiDataMappingStartPayloadMappingType["schema"] = "schema";
    UiDataMappingStartPayloadMappingType["expression"] = "expression";
    UiDataMappingStartPayloadMappingType["join"] = "join";
    UiDataMappingStartPayloadMappingType["aggregate"] = "aggregate";
})(UiDataMappingStartPayloadMappingType || (UiDataMappingStartPayloadMappingType = {}));
export var UiFabricConnectionAttemptFailedPayloadFabricType;
(function (UiFabricConnectionAttemptFailedPayloadFabricType) {
    UiFabricConnectionAttemptFailedPayloadFabricType["Databricks"] = "Databricks";
    UiFabricConnectionAttemptFailedPayloadFabricType["Snowflake"] = "Snowflake";
    UiFabricConnectionAttemptFailedPayloadFabricType["BigQuery"] = "BigQuery";
    UiFabricConnectionAttemptFailedPayloadFabricType["DuckDB"] = "DuckDB";
    UiFabricConnectionAttemptFailedPayloadFabricType["ProphecyManaged"] = "ProphecyManaged";
})(UiFabricConnectionAttemptFailedPayloadFabricType || (UiFabricConnectionAttemptFailedPayloadFabricType = {}));
export var UiFabricConnectionAutoAttachSkippedPayloadFabricType;
(function (UiFabricConnectionAutoAttachSkippedPayloadFabricType) {
    UiFabricConnectionAutoAttachSkippedPayloadFabricType["Databricks"] = "Databricks";
    UiFabricConnectionAutoAttachSkippedPayloadFabricType["Snowflake"] = "Snowflake";
    UiFabricConnectionAutoAttachSkippedPayloadFabricType["BigQuery"] = "BigQuery";
    UiFabricConnectionAutoAttachSkippedPayloadFabricType["DuckDB"] = "DuckDB";
    UiFabricConnectionAutoAttachSkippedPayloadFabricType["ProphecyManaged"] = "ProphecyManaged";
})(UiFabricConnectionAutoAttachSkippedPayloadFabricType || (UiFabricConnectionAutoAttachSkippedPayloadFabricType = {}));
export var UiFabricConnectionConnectedPayloadFabricType;
(function (UiFabricConnectionConnectedPayloadFabricType) {
    UiFabricConnectionConnectedPayloadFabricType["Databricks"] = "Databricks";
    UiFabricConnectionConnectedPayloadFabricType["Snowflake"] = "Snowflake";
    UiFabricConnectionConnectedPayloadFabricType["BigQuery"] = "BigQuery";
    UiFabricConnectionConnectedPayloadFabricType["DuckDB"] = "DuckDB";
    UiFabricConnectionConnectedPayloadFabricType["ProphecyManaged"] = "ProphecyManaged";
})(UiFabricConnectionConnectedPayloadFabricType || (UiFabricConnectionConnectedPayloadFabricType = {}));
export var UiFabricConnectionDisconnectedPayloadFabricType;
(function (UiFabricConnectionDisconnectedPayloadFabricType) {
    UiFabricConnectionDisconnectedPayloadFabricType["Databricks"] = "Databricks";
    UiFabricConnectionDisconnectedPayloadFabricType["Snowflake"] = "Snowflake";
    UiFabricConnectionDisconnectedPayloadFabricType["BigQuery"] = "BigQuery";
    UiFabricConnectionDisconnectedPayloadFabricType["DuckDB"] = "DuckDB";
    UiFabricConnectionDisconnectedPayloadFabricType["ProphecyManaged"] = "ProphecyManaged";
})(UiFabricConnectionDisconnectedPayloadFabricType || (UiFabricConnectionDisconnectedPayloadFabricType = {}));
export var UiFabricConnectionRetriesExhaustedPayloadFabricType;
(function (UiFabricConnectionRetriesExhaustedPayloadFabricType) {
    UiFabricConnectionRetriesExhaustedPayloadFabricType["Databricks"] = "Databricks";
    UiFabricConnectionRetriesExhaustedPayloadFabricType["Snowflake"] = "Snowflake";
    UiFabricConnectionRetriesExhaustedPayloadFabricType["BigQuery"] = "BigQuery";
    UiFabricConnectionRetriesExhaustedPayloadFabricType["DuckDB"] = "DuckDB";
    UiFabricConnectionRetriesExhaustedPayloadFabricType["ProphecyManaged"] = "ProphecyManaged";
})(UiFabricConnectionRetriesExhaustedPayloadFabricType || (UiFabricConnectionRetriesExhaustedPayloadFabricType = {}));
export var UiFabricConnectionStartedPayloadFabricType;
(function (UiFabricConnectionStartedPayloadFabricType) {
    UiFabricConnectionStartedPayloadFabricType["Databricks"] = "Databricks";
    UiFabricConnectionStartedPayloadFabricType["Snowflake"] = "Snowflake";
    UiFabricConnectionStartedPayloadFabricType["BigQuery"] = "BigQuery";
    UiFabricConnectionStartedPayloadFabricType["DuckDB"] = "DuckDB";
    UiFabricConnectionStartedPayloadFabricType["ProphecyManaged"] = "ProphecyManaged";
})(UiFabricConnectionStartedPayloadFabricType || (UiFabricConnectionStartedPayloadFabricType = {}));
export var UiFabricConnectionTestedPayloadFabricType;
(function (UiFabricConnectionTestedPayloadFabricType) {
    UiFabricConnectionTestedPayloadFabricType["Databricks"] = "Databricks";
    UiFabricConnectionTestedPayloadFabricType["Snowflake"] = "Snowflake";
    UiFabricConnectionTestedPayloadFabricType["BigQuery"] = "BigQuery";
    UiFabricConnectionTestedPayloadFabricType["DuckDB"] = "DuckDB";
    UiFabricConnectionTestedPayloadFabricType["ProphecyManaged"] = "ProphecyManaged";
})(UiFabricConnectionTestedPayloadFabricType || (UiFabricConnectionTestedPayloadFabricType = {}));
export var UiFabricConnectionTestedPayloadStatus;
(function (UiFabricConnectionTestedPayloadStatus) {
    UiFabricConnectionTestedPayloadStatus["success"] = "success";
    UiFabricConnectionTestedPayloadStatus["failure"] = "failure";
})(UiFabricConnectionTestedPayloadStatus || (UiFabricConnectionTestedPayloadStatus = {}));
export var UiFabricEntityCreationSuccessfulPayloadFabricType;
(function (UiFabricEntityCreationSuccessfulPayloadFabricType) {
    UiFabricEntityCreationSuccessfulPayloadFabricType["Databricks"] = "Databricks";
    UiFabricEntityCreationSuccessfulPayloadFabricType["Snowflake"] = "Snowflake";
    UiFabricEntityCreationSuccessfulPayloadFabricType["BigQuery"] = "BigQuery";
    UiFabricEntityCreationSuccessfulPayloadFabricType["DuckDB"] = "DuckDB";
    UiFabricEntityCreationSuccessfulPayloadFabricType["ProphecyManaged"] = "ProphecyManaged";
})(UiFabricEntityCreationSuccessfulPayloadFabricType || (UiFabricEntityCreationSuccessfulPayloadFabricType = {}));
export var UiGemModeTogglePayloadFrom;
(function (UiGemModeTogglePayloadFrom) {
    UiGemModeTogglePayloadFrom["simple"] = "simple";
    UiGemModeTogglePayloadFrom["advanced"] = "advanced";
})(UiGemModeTogglePayloadFrom || (UiGemModeTogglePayloadFrom = {}));
export var UiGemModeTogglePayloadTo;
(function (UiGemModeTogglePayloadTo) {
    UiGemModeTogglePayloadTo["simple"] = "simple";
    UiGemModeTogglePayloadTo["advanced"] = "advanced";
})(UiGemModeTogglePayloadTo || (UiGemModeTogglePayloadTo = {}));
export var UiGemModeTogglePayloadSource;
(function (UiGemModeTogglePayloadSource) {
    UiGemModeTogglePayloadSource["toggle"] = "toggle";
    UiGemModeTogglePayloadSource["tooComplexCard"] = "tooComplexCard";
})(UiGemModeTogglePayloadSource || (UiGemModeTogglePayloadSource = {}));
export var UiGemTooComplexPayloadReason;
(function (UiGemTooComplexPayloadReason) {
    UiGemTooComplexPayloadReason["expression"] = "expression";
    UiGemTooComplexPayloadReason["ports"] = "ports";
    UiGemTooComplexPayloadReason["conditions"] = "conditions";
    UiGemTooComplexPayloadReason["joinType"] = "joinType";
    UiGemTooComplexPayloadReason["conditionExpression"] = "conditionExpression";
    UiGemTooComplexPayloadReason["outputExpressions"] = "outputExpressions";
})(UiGemTooComplexPayloadReason || (UiGemTooComplexPayloadReason = {}));
export var UiIdePipelineAddNewNodePayloadGemCategory;
(function (UiIdePipelineAddNewNodePayloadGemCategory) {
    UiIdePipelineAddNewNodePayloadGemCategory["source"] = "source";
    UiIdePipelineAddNewNodePayloadGemCategory["transform"] = "transform";
    UiIdePipelineAddNewNodePayloadGemCategory["target"] = "target";
    UiIdePipelineAddNewNodePayloadGemCategory["ml"] = "ml";
    UiIdePipelineAddNewNodePayloadGemCategory["custom"] = "custom";
})(UiIdePipelineAddNewNodePayloadGemCategory || (UiIdePipelineAddNewNodePayloadGemCategory = {}));
export var UiMetadataCreateFabricPayloadFabricType;
(function (UiMetadataCreateFabricPayloadFabricType) {
    UiMetadataCreateFabricPayloadFabricType["Databricks"] = "Databricks";
    UiMetadataCreateFabricPayloadFabricType["Snowflake"] = "Snowflake";
    UiMetadataCreateFabricPayloadFabricType["BigQuery"] = "BigQuery";
    UiMetadataCreateFabricPayloadFabricType["DuckDB"] = "DuckDB";
    UiMetadataCreateFabricPayloadFabricType["ProphecyManaged"] = "ProphecyManaged";
})(UiMetadataCreateFabricPayloadFabricType || (UiMetadataCreateFabricPayloadFabricType = {}));
export var UiOnboardingFabricCreatePayloadFabricType;
(function (UiOnboardingFabricCreatePayloadFabricType) {
    UiOnboardingFabricCreatePayloadFabricType["Databricks"] = "Databricks";
    UiOnboardingFabricCreatePayloadFabricType["Snowflake"] = "Snowflake";
    UiOnboardingFabricCreatePayloadFabricType["BigQuery"] = "BigQuery";
    UiOnboardingFabricCreatePayloadFabricType["DuckDB"] = "DuckDB";
    UiOnboardingFabricCreatePayloadFabricType["ProphecyManaged"] = "ProphecyManaged";
})(UiOnboardingFabricCreatePayloadFabricType || (UiOnboardingFabricCreatePayloadFabricType = {}));
export var UiOnboardingHomeFlowTypePayloadFlowType;
(function (UiOnboardingHomeFlowTypePayloadFlowType) {
    UiOnboardingHomeFlowTypePayloadFlowType["sql"] = "sql";
    UiOnboardingHomeFlowTypePayloadFlowType["spark"] = "spark";
})(UiOnboardingHomeFlowTypePayloadFlowType || (UiOnboardingHomeFlowTypePayloadFlowType = {}));
export var UiOnboardingPipelineEnvInfoPayloadLanguage;
(function (UiOnboardingPipelineEnvInfoPayloadLanguage) {
    UiOnboardingPipelineEnvInfoPayloadLanguage["python"] = "python";
    UiOnboardingPipelineEnvInfoPayloadLanguage["scala"] = "scala";
    UiOnboardingPipelineEnvInfoPayloadLanguage["sql"] = "sql";
})(UiOnboardingPipelineEnvInfoPayloadLanguage || (UiOnboardingPipelineEnvInfoPayloadLanguage = {}));
export var UiOnboardingPipelineEnvInfoPayloadFabricType;
(function (UiOnboardingPipelineEnvInfoPayloadFabricType) {
    UiOnboardingPipelineEnvInfoPayloadFabricType["Databricks"] = "Databricks";
    UiOnboardingPipelineEnvInfoPayloadFabricType["Snowflake"] = "Snowflake";
    UiOnboardingPipelineEnvInfoPayloadFabricType["BigQuery"] = "BigQuery";
    UiOnboardingPipelineEnvInfoPayloadFabricType["DuckDB"] = "DuckDB";
    UiOnboardingPipelineEnvInfoPayloadFabricType["ProphecyManaged"] = "ProphecyManaged";
})(UiOnboardingPipelineEnvInfoPayloadFabricType || (UiOnboardingPipelineEnvInfoPayloadFabricType = {}));
export var UiOnboardingProjectCreatePayloadLanguage;
(function (UiOnboardingProjectCreatePayloadLanguage) {
    UiOnboardingProjectCreatePayloadLanguage["python"] = "python";
    UiOnboardingProjectCreatePayloadLanguage["scala"] = "scala";
    UiOnboardingProjectCreatePayloadLanguage["sql"] = "sql";
})(UiOnboardingProjectCreatePayloadLanguage || (UiOnboardingProjectCreatePayloadLanguage = {}));
export var UiPageCallSummaryPayloadKind;
(function (UiPageCallSummaryPayloadKind) {
    UiPageCallSummaryPayloadKind["graphql"] = "graphql";
    UiPageCallSummaryPayloadKind["ws"] = "ws";
    UiPageCallSummaryPayloadKind["rest"] = "rest";
})(UiPageCallSummaryPayloadKind || (UiPageCallSummaryPayloadKind = {}));
export var UiPageLoadPayloadMode;
(function (UiPageLoadPayloadMode) {
    UiPageLoadPayloadMode["reload"] = "reload";
    UiPageLoadPayloadMode["spa"] = "spa";
})(UiPageLoadPayloadMode || (UiPageLoadPayloadMode = {}));
export var UiPageSigninLoginAttemptPayloadAuthMethod;
(function (UiPageSigninLoginAttemptPayloadAuthMethod) {
    UiPageSigninLoginAttemptPayloadAuthMethod["email"] = "email";
    UiPageSigninLoginAttemptPayloadAuthMethod["google"] = "google";
    UiPageSigninLoginAttemptPayloadAuthMethod["sso"] = "sso";
    UiPageSigninLoginAttemptPayloadAuthMethod["discourse"] = "discourse";
})(UiPageSigninLoginAttemptPayloadAuthMethod || (UiPageSigninLoginAttemptPayloadAuthMethod = {}));
export var UiPageSignupCreateTeamButtonClickedPayloadAuthMethod;
(function (UiPageSignupCreateTeamButtonClickedPayloadAuthMethod) {
    UiPageSignupCreateTeamButtonClickedPayloadAuthMethod["email"] = "email";
    UiPageSignupCreateTeamButtonClickedPayloadAuthMethod["google"] = "google";
    UiPageSignupCreateTeamButtonClickedPayloadAuthMethod["sso"] = "sso";
})(UiPageSignupCreateTeamButtonClickedPayloadAuthMethod || (UiPageSignupCreateTeamButtonClickedPayloadAuthMethod = {}));
export var UiPageSignupStepCompletedPayloadMode;
(function (UiPageSignupStepCompletedPayloadMode) {
    UiPageSignupStepCompletedPayloadMode["reload"] = "reload";
    UiPageSignupStepCompletedPayloadMode["spa"] = "spa";
})(UiPageSignupStepCompletedPayloadMode || (UiPageSignupStepCompletedPayloadMode = {}));
export var UiPageSignupStepCompletedPayloadAuthMethod;
(function (UiPageSignupStepCompletedPayloadAuthMethod) {
    UiPageSignupStepCompletedPayloadAuthMethod["email"] = "email";
    UiPageSignupStepCompletedPayloadAuthMethod["google"] = "google";
    UiPageSignupStepCompletedPayloadAuthMethod["sso"] = "sso";
})(UiPageSignupStepCompletedPayloadAuthMethod || (UiPageSignupStepCompletedPayloadAuthMethod = {}));
export var UiPageSignupStepOtpPayloadAuthMethod;
(function (UiPageSignupStepOtpPayloadAuthMethod) {
    UiPageSignupStepOtpPayloadAuthMethod["email"] = "email";
    UiPageSignupStepOtpPayloadAuthMethod["google"] = "google";
    UiPageSignupStepOtpPayloadAuthMethod["sso"] = "sso";
})(UiPageSignupStepOtpPayloadAuthMethod || (UiPageSignupStepOtpPayloadAuthMethod = {}));
export var UiPageSignupStepPasswordPayloadAuthMethod;
(function (UiPageSignupStepPasswordPayloadAuthMethod) {
    UiPageSignupStepPasswordPayloadAuthMethod["email"] = "email";
    UiPageSignupStepPasswordPayloadAuthMethod["google"] = "google";
    UiPageSignupStepPasswordPayloadAuthMethod["sso"] = "sso";
})(UiPageSignupStepPasswordPayloadAuthMethod || (UiPageSignupStepPasswordPayloadAuthMethod = {}));
export var UiPageSignupStepSignupPayloadAuthMethod;
(function (UiPageSignupStepSignupPayloadAuthMethod) {
    UiPageSignupStepSignupPayloadAuthMethod["email"] = "email";
    UiPageSignupStepSignupPayloadAuthMethod["google"] = "google";
    UiPageSignupStepSignupPayloadAuthMethod["sso"] = "sso";
})(UiPageSignupStepSignupPayloadAuthMethod || (UiPageSignupStepSignupPayloadAuthMethod = {}));
export var UiPageSignupStepUserProfilePayloadAuthMethod;
(function (UiPageSignupStepUserProfilePayloadAuthMethod) {
    UiPageSignupStepUserProfilePayloadAuthMethod["email"] = "email";
    UiPageSignupStepUserProfilePayloadAuthMethod["google"] = "google";
    UiPageSignupStepUserProfilePayloadAuthMethod["sso"] = "sso";
})(UiPageSignupStepUserProfilePayloadAuthMethod || (UiPageSignupStepUserProfilePayloadAuthMethod = {}));
export var UiPageSignupVerifyOTPButtonClickedPayloadAuthMethod;
(function (UiPageSignupVerifyOTPButtonClickedPayloadAuthMethod) {
    UiPageSignupVerifyOTPButtonClickedPayloadAuthMethod["email"] = "email";
    UiPageSignupVerifyOTPButtonClickedPayloadAuthMethod["google"] = "google";
    UiPageSignupVerifyOTPButtonClickedPayloadAuthMethod["sso"] = "sso";
})(UiPageSignupVerifyOTPButtonClickedPayloadAuthMethod || (UiPageSignupVerifyOTPButtonClickedPayloadAuthMethod = {}));
export var UiPipelineEntityCreationSuccessfulPayloadPipelineType;
(function (UiPipelineEntityCreationSuccessfulPayloadPipelineType) {
    UiPipelineEntityCreationSuccessfulPayloadPipelineType["batch"] = "batch";
    UiPipelineEntityCreationSuccessfulPayloadPipelineType["streaming"] = "streaming";
})(UiPipelineEntityCreationSuccessfulPayloadPipelineType || (UiPipelineEntityCreationSuccessfulPayloadPipelineType = {}));
export var UiPipelineEntityCreationSuccessfulPayloadSource;
(function (UiPipelineEntityCreationSuccessfulPayloadSource) {
    UiPipelineEntityCreationSuccessfulPayloadSource["blank"] = "blank";
    UiPipelineEntityCreationSuccessfulPayloadSource["template"] = "template";
    UiPipelineEntityCreationSuccessfulPayloadSource["ai"] = "ai";
})(UiPipelineEntityCreationSuccessfulPayloadSource || (UiPipelineEntityCreationSuccessfulPayloadSource = {}));
export var UiPipelineEntityCreationSuccessfulPayloadLanguage;
(function (UiPipelineEntityCreationSuccessfulPayloadLanguage) {
    UiPipelineEntityCreationSuccessfulPayloadLanguage["scala"] = "scala";
    UiPipelineEntityCreationSuccessfulPayloadLanguage["python"] = "python";
    UiPipelineEntityCreationSuccessfulPayloadLanguage["sql"] = "sql";
})(UiPipelineEntityCreationSuccessfulPayloadLanguage || (UiPipelineEntityCreationSuccessfulPayloadLanguage = {}));
export var UiProjectEntityCreationSuccessfulPayloadLanguage;
(function (UiProjectEntityCreationSuccessfulPayloadLanguage) {
    UiProjectEntityCreationSuccessfulPayloadLanguage["python"] = "python";
    UiProjectEntityCreationSuccessfulPayloadLanguage["sql"] = "sql";
    UiProjectEntityCreationSuccessfulPayloadLanguage["scala"] = "scala";
})(UiProjectEntityCreationSuccessfulPayloadLanguage || (UiProjectEntityCreationSuccessfulPayloadLanguage = {}));
export var UiProjectEntityCreationSuccessfulPayloadSource;
(function (UiProjectEntityCreationSuccessfulPayloadSource) {
    UiProjectEntityCreationSuccessfulPayloadSource["blank"] = "blank";
    UiProjectEntityCreationSuccessfulPayloadSource["template"] = "template";
    UiProjectEntityCreationSuccessfulPayloadSource["ai"] = "ai";
})(UiProjectEntityCreationSuccessfulPayloadSource || (UiProjectEntityCreationSuccessfulPayloadSource = {}));
export var UiRunJobPayloadFabricType;
(function (UiRunJobPayloadFabricType) {
    UiRunJobPayloadFabricType["Databricks"] = "Databricks";
    UiRunJobPayloadFabricType["Snowflake"] = "Snowflake";
    UiRunJobPayloadFabricType["BigQuery"] = "BigQuery";
    UiRunJobPayloadFabricType["DuckDB"] = "DuckDB";
    UiRunJobPayloadFabricType["ProphecyManaged"] = "ProphecyManaged";
})(UiRunJobPayloadFabricType || (UiRunJobPayloadFabricType = {}));
export var UiTemplateGalleryViewedPayloadEntryPoint;
(function (UiTemplateGalleryViewedPayloadEntryPoint) {
    UiTemplateGalleryViewedPayloadEntryPoint["newProject"] = "newProject";
    UiTemplateGalleryViewedPayloadEntryPoint["onboarding"] = "onboarding";
    UiTemplateGalleryViewedPayloadEntryPoint["home"] = "home";
})(UiTemplateGalleryViewedPayloadEntryPoint || (UiTemplateGalleryViewedPayloadEntryPoint = {}));
export var UiTemplatePreviewedPayloadTemplateType;
(function (UiTemplatePreviewedPayloadTemplateType) {
    UiTemplatePreviewedPayloadTemplateType["pipeline"] = "pipeline";
    UiTemplatePreviewedPayloadTemplateType["project"] = "project";
    UiTemplatePreviewedPayloadTemplateType["app"] = "app";
})(UiTemplatePreviewedPayloadTemplateType || (UiTemplatePreviewedPayloadTemplateType = {}));
export var UiTemplateUsedPayloadTemplateType;
(function (UiTemplateUsedPayloadTemplateType) {
    UiTemplateUsedPayloadTemplateType["pipeline"] = "pipeline";
    UiTemplateUsedPayloadTemplateType["project"] = "project";
    UiTemplateUsedPayloadTemplateType["app"] = "app";
})(UiTemplateUsedPayloadTemplateType || (UiTemplateUsedPayloadTemplateType = {}));
export var UiTemplateUsedPayloadEntryPoint;
(function (UiTemplateUsedPayloadEntryPoint) {
    UiTemplateUsedPayloadEntryPoint["gallery"] = "gallery";
    UiTemplateUsedPayloadEntryPoint["onboarding"] = "onboarding";
})(UiTemplateUsedPayloadEntryPoint || (UiTemplateUsedPayloadEntryPoint = {}));
export var UiTranspilerImportTranspilationFailedPayloadSourceFormat;
(function (UiTranspilerImportTranspilationFailedPayloadSourceFormat) {
    UiTranspilerImportTranspilationFailedPayloadSourceFormat["informatica"] = "informatica";
    UiTranspilerImportTranspilationFailedPayloadSourceFormat["abinitio"] = "abinitio";
    UiTranspilerImportTranspilationFailedPayloadSourceFormat["datastage"] = "datastage";
})(UiTranspilerImportTranspilationFailedPayloadSourceFormat || (UiTranspilerImportTranspilationFailedPayloadSourceFormat = {}));
export var UiTranspilerImportTranspilationStartPayloadSourceFormat;
(function (UiTranspilerImportTranspilationStartPayloadSourceFormat) {
    UiTranspilerImportTranspilationStartPayloadSourceFormat["informatica"] = "informatica";
    UiTranspilerImportTranspilationStartPayloadSourceFormat["abinitio"] = "abinitio";
    UiTranspilerImportTranspilationStartPayloadSourceFormat["datastage"] = "datastage";
})(UiTranspilerImportTranspilationStartPayloadSourceFormat || (UiTranspilerImportTranspilationStartPayloadSourceFormat = {}));
export var UiTranspilerImportTranspilationSuccessPayloadSourceFormat;
(function (UiTranspilerImportTranspilationSuccessPayloadSourceFormat) {
    UiTranspilerImportTranspilationSuccessPayloadSourceFormat["informatica"] = "informatica";
    UiTranspilerImportTranspilationSuccessPayloadSourceFormat["abinitio"] = "abinitio";
    UiTranspilerImportTranspilationSuccessPayloadSourceFormat["datastage"] = "datastage";
})(UiTranspilerImportTranspilationSuccessPayloadSourceFormat || (UiTranspilerImportTranspilationSuccessPayloadSourceFormat = {}));
export var ActorType;
(function (ActorType) {
    ActorType["user"] = "user";
    ActorType["system"] = "system";
    ActorType["AI"] = "AI";
    ActorType["scheduler"] = "scheduler";
    ActorType["apiKey"] = "apiKey";
    ActorType["agent"] = "agent";
})(ActorType || (ActorType = {}));
export var ContextResourceType;
(function (ContextResourceType) {
    ContextResourceType["Pipeline"] = "Pipeline";
    ContextResourceType["SQLPipeline"] = "SQLPipeline";
    ContextResourceType["Project"] = "Project";
    ContextResourceType["Job"] = "Job";
    ContextResourceType["Team"] = "Team";
    ContextResourceType["User"] = "User";
})(ContextResourceType || (ContextResourceType = {}));
export var ErrorInfoSeverity;
(function (ErrorInfoSeverity) {
    ErrorInfoSeverity["debug"] = "debug";
    ErrorInfoSeverity["info"] = "info";
    ErrorInfoSeverity["warn"] = "warn";
    ErrorInfoSeverity["error"] = "error";
    ErrorInfoSeverity["fatal"] = "fatal";
})(ErrorInfoSeverity || (ErrorInfoSeverity = {}));
export var Status;
(function (Status) {
    Status["success"] = "success";
    Status["failure"] = "failure";
    Status["partial"] = "partial";
    Status["cancelled"] = "cancelled";
    Status["inProgress"] = "inProgress";
})(Status || (Status = {}));
export var AnalysisEditOperation;
(function (AnalysisEditOperation) {
    AnalysisEditOperation["widget_add"] = "widget.add";
    AnalysisEditOperation["widget_remove"] = "widget.remove";
    AnalysisEditOperation["widget_update"] = "widget.update";
    AnalysisEditOperation["layout_change"] = "layout.change";
    AnalysisEditOperation["settings_change"] = "settings.change";
})(AnalysisEditOperation || (AnalysisEditOperation = {}));
export var AnalysisMode;
(function (AnalysisMode) {
    AnalysisMode["edit"] = "edit";
    AnalysisMode["preview"] = "preview";
    AnalysisMode["live"] = "live";
})(AnalysisMode || (AnalysisMode = {}));
export var ApiMethod;
(function (ApiMethod) {
    ApiMethod["GET"] = "GET";
    ApiMethod["POST"] = "POST";
    ApiMethod["PUT"] = "PUT";
    ApiMethod["DELETE"] = "DELETE";
    ApiMethod["graphql"] = "graphql";
})(ApiMethod || (ApiMethod = {}));
export var AutoAttachSkipReason;
(function (AutoAttachSkipReason) {
    AutoAttachSkipReason["blocked"] = "blocked";
    AutoAttachSkipReason["noFabric"] = "noFabric";
    AutoAttachSkipReason["autoAttachDisabled"] = "autoAttachDisabled";
    AutoAttachSkipReason["snapshotMode"] = "snapshotMode";
    AutoAttachSkipReason["orchestrationDisabled"] = "orchestrationDisabled";
    AutoAttachSkipReason["fabricInvalid"] = "fabricInvalid";
    AutoAttachSkipReason["tabInactive"] = "tabInactive";
    AutoAttachSkipReason["transitionNotRetryable"] = "transitionNotRetryable";
})(AutoAttachSkipReason || (AutoAttachSkipReason = {}));
export var CanvasSource;
(function (CanvasSource) {
    CanvasSource["manual"] = "manual";
    CanvasSource["ai"] = "ai";
})(CanvasSource || (CanvasSource = {}));
export var CanvasTarget;
(function (CanvasTarget) {
    CanvasTarget["gem"] = "gem";
    CanvasTarget["port"] = "port";
    CanvasTarget["column"] = "column";
    CanvasTarget["pipeline"] = "pipeline";
})(CanvasTarget || (CanvasTarget = {}));
export var ClusterConnectionStatus;
(function (ClusterConnectionStatus) {
    ClusterConnectionStatus["DETACHED"] = "DETACHED";
    ClusterConnectionStatus["ATTACHING"] = "ATTACHING";
    ClusterConnectionStatus["ATTACHED"] = "ATTACHED";
    ClusterConnectionStatus["CONNECTION_ERROR"] = "CONNECTION_ERROR";
    ClusterConnectionStatus["RUNNING"] = "RUNNING";
    ClusterConnectionStatus["SUCCESS"] = "SUCCESS";
    ClusterConnectionStatus["ERROR"] = "ERROR";
    ClusterConnectionStatus["CANCELLED"] = "CANCELLED";
})(ClusterConnectionStatus || (ClusterConnectionStatus = {}));
export var CodeGenOperation;
(function (CodeGenOperation) {
    CodeGenOperation["generateCode"] = "generateCode";
    CodeGenOperation["rebuildCode"] = "rebuildCode";
    CodeGenOperation["generateLineage"] = "generateLineage";
})(CodeGenOperation || (CodeGenOperation = {}));
export var CompileScope;
(function (CompileScope) {
    CompileScope["gem"] = "gem";
    CompileScope["pipeline"] = "pipeline";
    CompileScope["project"] = "project";
})(CompileScope || (CompileScope = {}));
export var ConnectionTrigger;
(function (ConnectionTrigger) {
    ConnectionTrigger["manual"] = "manual";
    ConnectionTrigger["automatic"] = "automatic";
})(ConnectionTrigger || (ConnectionTrigger = {}));
export var DisconnectReason;
(function (DisconnectReason) {
    DisconnectReason["inactivity"] = "inactivity";
    DisconnectReason["error"] = "error";
    DisconnectReason["networkChange"] = "networkChange";
    DisconnectReason["manual"] = "manual";
})(DisconnectReason || (DisconnectReason = {}));
export var EntityKind;
(function (EntityKind) {
    EntityKind["Pipeline"] = "Pipeline";
    EntityKind["SQLPipeline"] = "SQLPipeline";
})(EntityKind || (EntityKind = {}));
export var EntityOperation;
(function (EntityOperation) {
    EntityOperation["create"] = "create";
    EntityOperation["update"] = "update";
    EntityOperation["reset"] = "reset";
})(EntityOperation || (EntityOperation = {}));
export var EntityType;
(function (EntityType) {
    EntityType["pipeline"] = "pipeline";
    EntityType["job"] = "job";
    EntityType["sqlProject"] = "sqlProject";
})(EntityType || (EntityType = {}));
export var ErrorKind;
(function (ErrorKind) {
    ErrorKind["runtime"] = "runtime";
    ErrorKind["diagnostic"] = "diagnostic";
})(ErrorKind || (ErrorKind = {}));
export var ErrorSource;
(function (ErrorSource) {
    ErrorSource["llm"] = "llm";
    ErrorSource["tool"] = "tool";
    ErrorSource["validation"] = "validation";
    ErrorSource["timeout"] = "timeout";
    ErrorSource["internal"] = "internal";
})(ErrorSource || (ErrorSource = {}));
export var FabricType;
(function (FabricType) {
    FabricType["Databricks"] = "Databricks";
    FabricType["Snowflake"] = "Snowflake";
    FabricType["BigQuery"] = "BigQuery";
    FabricType["DuckDB"] = "DuckDB";
    FabricType["ProphecyManaged"] = "ProphecyManaged";
})(FabricType || (FabricType = {}));
export var GemOperation;
(function (GemOperation) {
    GemOperation["added"] = "added";
    GemOperation["removed"] = "removed";
    GemOperation["moved"] = "moved";
    GemOperation["updated"] = "updated";
    GemOperation["renamed"] = "renamed";
    GemOperation["connected"] = "connected";
    GemOperation["portAdded"] = "portAdded";
    GemOperation["portRemoved"] = "portRemoved";
    GemOperation["copied"] = "copied";
    GemOperation["pasted"] = "pasted";
    GemOperation["gemSpliced"] = "gemSpliced";
    GemOperation["gemBranched"] = "gemBranched";
})(GemOperation || (GemOperation = {}));
export var GitOperationType;
(function (GitOperationType) {
    GitOperationType["commit"] = "commit";
    GitOperationType["push"] = "push";
    GitOperationType["pull"] = "pull";
    GitOperationType["clone"] = "clone";
    GitOperationType["checkout"] = "checkout";
    GitOperationType["merge"] = "merge";
    GitOperationType["reset"] = "reset";
})(GitOperationType || (GitOperationType = {}));
export var KnowledgeGraphOperation;
(function (KnowledgeGraphOperation) {
    KnowledgeGraphOperation["projectLineage"] = "projectLineage";
    KnowledgeGraphOperation["datasetColumnLineage"] = "datasetColumnLineage";
    KnowledgeGraphOperation["index"] = "index";
    KnowledgeGraphOperation["markStale"] = "markStale";
    KnowledgeGraphOperation["clearIndex"] = "clearIndex";
})(KnowledgeGraphOperation || (KnowledgeGraphOperation = {}));
export var Origin;
(function (Origin) {
    Origin["AI"] = "AI";
})(Origin || (Origin = {}));
export var PageLoadAssetEntryDelivery;
(function (PageLoadAssetEntryDelivery) {
    PageLoadAssetEntryDelivery["cached"] = "cached";
    PageLoadAssetEntryDelivery["revalidated"] = "revalidated";
    PageLoadAssetEntryDelivery["network"] = "network";
})(PageLoadAssetEntryDelivery || (PageLoadAssetEntryDelivery = {}));
export var PageLoadStage;
(function (PageLoadStage) {
    PageLoadStage["firstRequest"] = "firstRequest";
    PageLoadStage["navBarLoaded"] = "navBarLoaded";
    PageLoadStage["wsConnected"] = "wsConnected";
    PageLoadStage["renderCompleted"] = "renderCompleted";
    PageLoadStage["wsConnectedAt"] = "wsConnectedAt";
    PageLoadStage["renderCompletedAt"] = "renderCompletedAt";
    PageLoadStage["entityReadyAt"] = "entityReadyAt";
})(PageLoadStage || (PageLoadStage = {}));
export var PortSide;
(function (PortSide) {
    PortSide["input"] = "input";
    PortSide["output"] = "output";
})(PortSide || (PortSide = {}));
export var PrMergeOutcome;
(function (PrMergeOutcome) {
    PrMergeOutcome["merged"] = "merged";
    PrMergeOutcome["notFound"] = "notFound";
    PrMergeOutcome["failed"] = "failed";
})(PrMergeOutcome || (PrMergeOutcome = {}));
export var RunScope;
(function (RunScope) {
    RunScope["full"] = "full";
    RunScope["componentLevel"] = "componentLevel";
})(RunScope || (RunScope = {}));
export var RunTrigger;
(function (RunTrigger) {
    RunTrigger["manual"] = "manual";
    RunTrigger["automatic"] = "automatic";
})(RunTrigger || (RunTrigger = {}));
export var RunType;
(function (RunType) {
    RunType["interactivePipelineRun"] = "interactivePipelineRun";
    RunType["scheduled"] = "scheduled";
    RunType["interactiveAppRun"] = "interactiveAppRun";
    RunType["appSchedule"] = "appSchedule";
    RunType["apiPipelineRun"] = "apiPipelineRun";
})(RunType || (RunType = {}));
export var SandboxMode;
(function (SandboxMode) {
    SandboxMode["allocateExisting"] = "allocateExisting";
    SandboxMode["createNew"] = "createNew";
})(SandboxMode || (SandboxMode = {}));
export var SandboxType;
(function (SandboxType) {
    SandboxType["scala"] = "scala";
    SandboxType["python"] = "python";
    SandboxType["sql"] = "sql";
    SandboxType["go"] = "go";
})(SandboxType || (SandboxType = {}));
export var SpinnerType;
(function (SpinnerType) {
    SpinnerType["canvas"] = "canvas";
    SpinnerType["agent"] = "agent";
    SpinnerType["fullPage"] = "fullPage";
    SpinnerType["compilation"] = "compilation";
})(SpinnerType || (SpinnerType = {}));
export var TargetLanguage;
(function (TargetLanguage) {
    TargetLanguage["scala"] = "scala";
    TargetLanguage["python"] = "python";
    TargetLanguage["sql"] = "sql";
})(TargetLanguage || (TargetLanguage = {}));
export var UiErrorSource;
(function (UiErrorSource) {
    UiErrorSource["toast"] = "toast";
    UiErrorSource["banner"] = "banner";
    UiErrorSource["diagnostic"] = "diagnostic";
    UiErrorSource["lsp"] = "lsp";
    UiErrorSource["network"] = "network";
})(UiErrorSource || (UiErrorSource = {}));
export var UploadRejectReason;
(function (UploadRejectReason) {
    UploadRejectReason["empty"] = "empty";
    UploadRejectReason["perFileSizeLimit"] = "perFileSizeLimit";
    UploadRejectReason["totalSizeLimit"] = "totalSizeLimit";
    UploadRejectReason["safetyValidator"] = "safetyValidator";
})(UploadRejectReason || (UploadRejectReason = {}));
export var ViewType;
(function (ViewType) {
    ViewType["visual"] = "visual";
    ViewType["code"] = "code";
    ViewType["document"] = "document";
})(ViewType || (ViewType = {}));
